export const articleTestIds = {
  //prostore block
  proStoreBlock: 'prostore_block',

  //articles
  proStoreArticles: 'prostore_articles',
  proStoreArticlesTitle: 'prostore_articles_title',
  proStoreArticlesTitleLink: 'prostore_articles_title_link',
  proStoreItem: 'prostore_item',

  //games
  proStoreGames: 'prostore_games',
  proStoreGamesItem: 'games_of_the_month_item',

  //prostore_page
  proStorePageTitle: 'prostore_page_title',
  proStorePageArticles: 'prostore_page_articles',
  proStorePageArticle: 'prostore_page_article',
  proStorePageFootnote: 'prostore_page_footnote',

  //prostore_article_page
  proStoreArticlePageDate: 'prostore_article_page_date',
  proStoreArticlePageTitle: 'prostore_article_page_title',
  proStoreArticlePageImage: 'prostore_article_page_image',
  proStoreArticlePageSelectionItem: 'prostore_selection_item',

  //prostore_swiper
  proStoreSwiperPrevButton: 'prostore_swiper_prev_button',
  proStoreSwiperNextButton: 'prostore_swiper_next_button',

  //other
  backButton: 'back-button',
};

export const paginationTestIds = {
  paginationComponent: 'pagination',
  paginationPrevButton: 'prev',
  paginationNextButton: 'next',
};
